export default __webpack_public_path__ + "static/media/playlist-add.239277f5.svg";